<template>
  <div class="docs-container">
    <div class="pdf-container">
      <iframe :src="url" class="pdf-frame"></iframe>
    </div>
    <div class="pdf-download">
        <p>
          Viewing the PDF on mobile isn't supported
          <br/>
          <br/>
          <a href="/docs.pdf" download>But you can download it here</a>
        </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Docs',
  props: {
    url: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.docs-container {
  background-color: black;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}


.pdf-container {
  height: 100vh;
  margin: 0;
  padding: 0;
}

.pdf-frame {
  width: 100%;
  height: 100%;
  border: none;
}

.pdf-download {
  display: none;
  padding: 8px;
  text-align: center;
  color: white;
  background-color: black;
  width: 100vw;
  height: 100vh;
  a {
    color: lightblue;
  }
}

@media (max-width: 768px) {
  .pdf-container {
    display: none;
  }
  .pdf-download {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>
